import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import useSeo from "@/seo/useSeo";
import { ARTICLES } from "@/content/articles";
import Reveal from "@/components/Reveal";

export default function Discover() {
  useSeo("/decouvrir-haut-doubs");
  return (
    <div className="bg-ink pb-28 pt-32 sm:pt-40" data-testid="discover-page">
      <div className="mx-auto max-w-6xl px-6">
        <p className="mono-label text-brass">Carnet de voyage</p>
        <h1 className="display-xl mt-6 text-4xl text-bone sm:text-5xl lg:text-6xl">
          Découvrir le Haut-Doubs
        </h1>
        <p className="mt-8 max-w-2xl text-sm text-muted-foreground sm:text-base">
          Nos repères pour explorer Morteau, Villers-le-Lac et le Pays Horloger depuis Les Fins.
        </p>

        <div className="mt-20 grid gap-14 sm:grid-cols-2">
          {ARTICLES.map((a, i) => (
            <Reveal key={a.slug} delay={i * 90}>
              <article className="group flex h-full flex-col border border-white/10 bg-white/[0.02]"
                data-testid={`article-card-${a.slug}`}>
                <Link to={`/decouvrir-haut-doubs/${a.slug}`} className="block overflow-hidden">
                  <img src={a.image} alt={a.alt} loading={i > 1 ? "lazy" : "eager"} decoding="async"
                    className="h-56 w-full object-cover transition-transform duration-700 group-hover:scale-105 sm:h-64" />
                </Link>
                <div className="flex flex-1 flex-col p-7 sm:p-9">
                  <h2 className="font-display text-xl leading-snug text-bone md:text-2xl">
                    <Link to={`/decouvrir-haut-doubs/${a.slug}`} className="hover:text-brass">{a.h1}</Link>
                  </h2>
                  <p className="mt-5 flex-1 text-sm leading-relaxed text-muted-foreground">{a.card}</p>
                  <Link to={`/decouvrir-haut-doubs/${a.slug}`} data-testid={`article-link-${a.slug}`}
                    className="mono-label mt-8 inline-flex items-center gap-2 text-brass transition-colors hover:text-bone">
                    Lire l’article <ArrowRight size={14} />
                  </Link>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
